import { FaqCategory } from '../../models/faq.model';

export const FAQ_DATA: FaqCategory[] = [
  {
    title: 'General',
    items: [
      { 
        question: 'What is Horizinns?', 
        answer: 'We are a direct-to-host platform that connects renters directly with property owners, eliminating middleman fees.' 
      },
      { 
        question: 'Is it free?', 
        answer: 'Renter fees are <strong>$0</strong>. We believe you shouldn\'t pay to book a vacation.' 
      },
      {
        question: 'If no fees are applied, should I expect to pay the amount listed?',
        answer: 'Other fees applied to rentals are generally sales tax, cleaning fee, pet fee, etc…these are at the mercy of location and host.'
      },
      {
        question: 'Why is the map icon not completely accurate?',
        answer: 'We use Google mapping services and understand that the exact location is not always accurate. Please research the property and address prior to arrival. If an inaccuracy is discovered, please report it to <a href="/contact">Horizinns</a>.'
      }
    ]
  },
  {
    title: 'For Hosts',
    items: [
      { 
        question: 'How do I list?', 
        answer: 'Simply sign up, verify your identity, and click "Add Property" in your dashboard.' 
      },
      { 
        question: 'What is the fee?', 
        answer: 'We charge a <strong>$300 flat annual fee</strong> per property. No commissions per booking.' 
      },
      {
        question: 'Who do I contact if I have any issues or questions with my rental?',
        answer: 'The Host'
      },
      {
        question: 'How do I manage my properties?',
        answer: 'The Host has the ability to manage properties through the <i>Manage Property</i> dashboard.'
      }
    ]
  }
];